import { api } from '@/api';
import { Page } from '@/components/dashboard/page';
import { router } from '@/main';
import { LocationUpdateSchema } from '@shared/modelTypes/location-types';
import { createFileRoute } from '@tanstack/react-router';
import { Button, Col, Heading } from 'ht-sdk/react';
import { Form, resolver, TextField } from 'ht-sdk/react/forms';
import { useForm } from 'react-hook-form';
import { toast } from 'sonner';

export const Route = createFileRoute('/dashboard/locations/$id/edit')({
	component: RouteComponent,
	loader: async ({ params }) => {
		const location = await api.locationGet({ id: params.id });
		return {
			location: location.success ? location.data : null,
		};
	},
});

function RouteComponent() {
	const data = Route.useLoaderData();

	const form = useForm({
		resolver: resolver(LocationUpdateSchema),
		defaultValues: data.location!,
	});
	const errors = form.formState.errors;
	console.log('all the errors', errors);

	if (!data.location) {
		return (
			<Page>
				<Heading>Location not found</Heading>
			</Page>
		);
	}

	return (
		<Page>
			<Heading>Edit Location</Heading>
			<Form
				methods={form}
				onSubmit={async (data) => {
					console.log('onSubmit', data);

					const res = await api.locationUpdate(data);
					if (!res.success) {
						toast.error(res.message);
						return;
					} else {
						toast.success('Location updated successfully');
						router.invalidate();
						router.navigate({ to: '/dashboard/locations' });
					}
				}}
				onInvalid={(errors) => {
					console.log('got errors', errors);
				}}
			>
				<Col gap={3}>
					<TextField name="name" label="Name" placeholder="Name" />
					<TextField name="code" label="Code" placeholder="Code" className="font-mono uppercase" />
					<Button type="submit" className="cursor-pointer">
						Save
					</Button>
				</Col>
			</Form>
		</Page>
	);
}
